import { SubtitleTrack } from '@smart-tv/components/player/types';
import formatLanguage from '@smart-tv/utils/formatter/format-language';

export const getSubtitleTrackDisplayText = (subtitleTrack: SubtitleTrack) => {
  const { lang, label } = subtitleTrack;

  const language = formatLanguage(lang);

  const labelIsCC = label.includes('[SDH]');

  return labelIsCC ? `${language} (CC)` : language;
};

export default getSubtitleTrackDisplayText;
